export const MenuOptionsAll = {
  NEW: 'New',
  NEW_KENSHIN: 'New_Kenshin',
  TASKMANAGEMENT: 'TaskManagement',
  TASKMANAGEMENT_KENSHIN: 'TaskManagement_Kenshin',
  HISTORY: 'History',
  HISTORY_KENSHIN: 'History_Kenshin',
  ASSIGNMENT: 'Assignment',
  CONTACTS: 'Contacts',
  BILLING: 'Billing',
  PAIDWAGE: 'PaidWage',
  MYWAGE: 'MyWage',
  ORGSETTINGS: 'OrganizationSettings',
  ORGLOGS: 'OrganizationLogs',
  MANUAL: 'Manual',
  SERVICETERMS: 'ServiceTerms',
  AI_SUMMARY: 'AiSummary',
};

export const MenuOptionsForManager = [
  MenuOptionsAll.NEW,
  MenuOptionsAll.NEW_KENSHIN,
  MenuOptionsAll.TASKMANAGEMENT,
  MenuOptionsAll.TASKMANAGEMENT_KENSHIN,
  MenuOptionsAll.HISTORY,
  MenuOptionsAll.HISTORY_KENSHIN,
  MenuOptionsAll.CONTACTS,
  MenuOptionsAll.BILLING,
  MenuOptionsAll.ORGSETTINGS,
  MenuOptionsAll.ORGLOGS,
  MenuOptionsAll.MANUAL,
  MenuOptionsAll.SERVICETERMS,
  MenuOptionsAll.AI_SUMMARY,
];

//! TODO Need to check this part
export const MenuOptionsForStaff = [
  MenuOptionsAll.NEW,
  MenuOptionsAll.TASKMANAGEMENT,
  MenuOptionsAll.HISTORY,
  MenuOptionsAll.CONTACTS,
  MenuOptionsAll.BILLING,
  MenuOptionsAll.MANUAL,
  MenuOptionsAll.SERVICETERMS,
];

export const MenuOptionsForDoctor = [
  MenuOptionsAll.ASSIGNMENT,
  MenuOptionsAll.CONTACTS,
  MenuOptionsAll.MANUAL,
  MenuOptionsAll.SERVICETERMS,
];

export const MenuOptionsDefault = [
  MenuOptionsAll.MANUAL,
  MenuOptionsAll.SERVICETERMS,
];
